export const SEARCH_INPUT_DEBOUNCE_TIMER = 300
export const INTERSECT_DEBOUNCE_TIMER = 500
export const FOLDER_ICON_COLOR = '#7BA9F9'
export const FOLDER_MAX_DEPTH = 1
export const APP_HEADER_HEIGHT = 64
export const ACCEPTED_DOCUMENT_TYPES = ".pdf, .doc, .docx"
export const ACCEPTED_DOWNLOAD_TYPES = [
  'application/pdf',
  'application/msword',
  'application/octet-stream',
]
export const DEFAULT_PAGINATION_STATE = {
  page: 1,
  pageSize: 25,
  pageCount: 1,
  itemCount: 1,
}

export const DEFAULT_PAGE_SIZE = 25

export const SEARCH_SNIPPET_NOTE_DISMISSED = 'search-snippet-note-dismissed'
export const BROADCAST = {
  CHANNELS: {
    DOCUMENT_REDACTION: 'closd-document-redaction',
  },
  MESSAGES: {
    DOCUMENT_REDACTION_UPDATED: 'DOCUMENT_REDACTION_UPDATED',
  },
}
